module.exports = __webpack_public_path__ + "static/scale-model-of-forest-theater-in-dallas-texas-d9ae68c8bc4fccee874f346080c58aa0.png";